export default __webpack_public_path__ + "static/media/atras.b05eb46c.png";